<h3 class="text-center">{{text}}</h3>
<div *ngIf="showReturn" class="col-12 text-center">
    <span class="spanLink blue-dark" (click)="retun()"> Retun </span>
</div>